enum COLORS_KEYS {
  BLUE_80 = 'BLUE_80',
  NEUTRALS_0 = 'NEUTRALS_0',
  NEUTRALS_600 = 'NEUTRALS_600',
  NEUTRALS_900 = 'NEUTRALS_900',

  BLACK = 'BLACK',
  SMOKEY_GREY = 'SMOKEY_GREY',
  GRANITE = 'GRANITE',
  WHITE_SMOKE = 'WHITE_SMOKE',
  SOFT_PEACH = 'SOFT_PEACH',
  LEMON_GRASS = 'LEMON_GRASS',
  CHARCOAL_GREY = 'CHARCOAL_GREY',
  WHITE = 'WHITE',
  NICE_BLUE = 'NICE_BLUE',
  CERULEAN = 'CERULEAN',
  PICTON_BLUE = 'PICTON_BLUE',
  CATSKILL_WHITE = 'CATSKILL_WHITE',
  LINK_WATER = 'LINK_WATER',
  SNOW_DRIFT = 'SNOW_DRIFT',
  STOPLIGHT_GO_GREEN = 'STOPLIGHT_GO_GREEN',
  CADMIUM_RED = 'CADMIUM_RED',
  NOTIFICATION_STATUS_POSITIVE = 'NOTIFICATION_STATUS_POSITIVE',
  NOTIFICATION_STATUS_NEGATIVE = 'NOTIFICATION_STATUS_NEGATIVE',
  PROJECT_STATUS_WARNING = 'PROJECT_STATUS_WARNING',
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace COLORS_KEYS {
  export function valueOf(str: string) {
    return COLORS_KEYS[str as keyof typeof COLORS_KEYS]
  }
}

export const COLORS: Record<COLORS_KEYS, string> = {
  [COLORS_KEYS.BLUE_80]: 'rgba(34, 139, 230, 0.8)',
  [COLORS_KEYS.NEUTRALS_0]: '#FFFFFF',
  [COLORS_KEYS.NEUTRALS_600]: '#87879B',
  [COLORS_KEYS.NEUTRALS_900]: '#101025',

  [COLORS_KEYS.BLACK]: '#000000',
  [COLORS_KEYS.SMOKEY_GREY]: '#737373',
  [COLORS_KEYS.GRANITE]: '#808080',
  [COLORS_KEYS.WHITE_SMOKE]: '#F5F5F5',
  [COLORS_KEYS.SOFT_PEACH]: '#EDEDED',
  [COLORS_KEYS.LEMON_GRASS]: '#999999',
  [COLORS_KEYS.CHARCOAL_GREY]: '#404040',
  [COLORS_KEYS.WHITE]: '#FFFFFF',
  [COLORS_KEYS.NICE_BLUE]: '#0579AB',
  [COLORS_KEYS.CERULEAN]: '#0A9EDE',
  [COLORS_KEYS.PICTON_BLUE]: '#45B2E0',
  [COLORS_KEYS.CATSKILL_WHITE]: '#EBF6FB',
  [COLORS_KEYS.LINK_WATER]: '#D4E8F1',
  [COLORS_KEYS.SNOW_DRIFT]: '#F7F9FA',
  [COLORS_KEYS.STOPLIGHT_GO_GREEN]: '#45E56D',
  [COLORS_KEYS.CADMIUM_RED]: '#E80230',
  [COLORS_KEYS.NOTIFICATION_STATUS_POSITIVE]: '#1B7A3A',
  [COLORS_KEYS.NOTIFICATION_STATUS_NEGATIVE]: '#B71C1C',
  [COLORS_KEYS.PROJECT_STATUS_WARNING]: '#FF9800',

  // BLACK COLORS
}

export const ZIndexes = {
  calendar: '1500',
  loader: '1601',
  dialog: '1501',
  modal: '1600',
  tableHead: '100',
}

export const headerHeight = '68px'
export const projectHeaderHeight = '175px'
export const projectEvaluationHeaderHeight = '106px'
export const footerHeight = '72px'
export const aupdHeaderHeight = '40px'
export const headerAndAupdHeight = '108px'
